/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const StartNativeRecoveryBody = zod.object({
  channel: zod.enum(['email', 'phone']),
  identifier: zod.string().min(1),
});

export type StartNativeRecoveryBody = zod.input<typeof StartNativeRecoveryBody>;
export type StartNativeRecoveryBodyOutput = zod.output<typeof StartNativeRecoveryBody>;
